/**
 * GA 统计接口
 * 相关需求文档：
 * - http://wiki.tools.zuzuche.com/pages/viewpage.action?pageId=25690396
 */
import { check as checkEvent } from './events';
import { isFunction } from '../../type';

const gtag = window.gtag;

export function event(name, params = {}) {
  if (!isFunction(gtag)) {
    return false;
  }
  // 检查是否已定义
  checkEvent(name);
  return gtag('event', name, params);
}
